import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useNetworkStatus } from '~/hooks';
import { Icon, IconLayer, IconCounter } from '~/utils';

export function NetworkMonitor( props ) {
  const { status, error, attempts } = useNetworkStatus();

  return (
    <Modal isOpen={status !== 'connected'} centered size="sm" backdrop>
      <ModalHeader>Disconnected ({status})</ModalHeader>
      <ModalBody className="text-center">
        <IconLayer className="network-error fa-10x">
          <Icon icon="fas:wifi" color="blue" />
          <Icon icon="fas:slash" className="slash" color="red" />
          { attempts && <IconCounter count={attempts} /> }
        </IconLayer>
      </ModalBody>
      <ModalFooter>
        { error || 'Disconnected from server!' }
      </ModalFooter>
    </Modal>
  );
}
